import { SERVER_URL } from "../system/appConfig";

export async function timeGet() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  try {
    const response = await fetch(`${SERVER_URL}/api/ts`, requestOptions);
    const json = await response.json();
    return json.ts;
  } catch (error) {
    console.error("timeGet error: ", error);
    return;
  }
}
